<template>

			<div class="card p-col-10">
				<h5>Certificador</h5>
                <div class="p-col-12 p-d-flex p-flex-column p-ai-center p-jc-center">
                    <div class="p-fluid">
                        <div class="p-field">
                            <label for="username" :class="{'p-error':v$.username.$invalid && submitted}">Username</label>
                            <InputText id="username" name="username" type="text"
                                        v-model="v$.username.$model" 
                                        :class="{'p-invalid':v$.username.$invalid && submitted}" />
                        </div>

                        <div class="p-field">
                            <label for="password" :class="{'p-error':v$.password.$invalid && submitted}">Password</label>
                            <InputText id="password" name="password" type="password"
                                        v-model="v$.password.$model" 
                                        :class="{'p-invalid':v$.password.$invalid && submitted}" />                
                        </div>

                    </div>
                    <div class="p-fluid">
                        <Button type="button" label="Login" :disabled="loggingIn" @click="handleSubmit(!v$.$invalid)" ></Button>
                    </div>
                            
                </div>          
			</div>
	
    
</template>

<script>

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'


export default {
     setup () {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            username: {
                required
            },
            password: {
                required
            }
        }
    },
    data () {
        return {
            username: '',
            password: '',
            submitted: false
        }
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        }
    },
    created () {
        // reset login status
        this.$store.dispatch('authentication/logout');
    },
    methods: {
        handleSubmit (isFormValid) {

            this.submitted = true;

             if (!isFormValid) {
                return;
            }


            const { username, password } = this;
            const { dispatch } = this.$store;
            if (username && password) {
                dispatch('authentication/login', { username, password });
            }
        }

       
    }
};
</script>